module.exports = __webpack_public_path__ + "img/logo-light.6b438f7a.png";